import PropTypes from 'prop-types';
import { ReducerStatus } from 'utils/constants';
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import ResultModal from './ResultModal';

function ConfirmationActionModal({
  onClose,
  onConfirm,
  onSubmitResult,
  isVisible,
  status,
  description,
  successMessage,
  error,
  children,
}) {
  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {status === ReducerStatus.SUCCEEDED || status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={isVisible}
          onSubmit={onSubmitResult}
          isError={status === ReducerStatus.FAILED}
          title={
            status === ReducerStatus.SUCCEEDED ? 'Success' : 'Server Error'
          }
          message={
            status === ReducerStatus.SUCCEEDED
              ? successMessage
              : error?.data?.title || 'Server Error'
          }
          errorObject={error?.data?.errors}
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal isOpen={isVisible} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{description}</ModalBody>
            {children && <Box px={4}>{children}</Box>}
            <ModalFooter>
              {/* Close button */}
              <Button colorScheme="gray" mr={3} onClick={onClose}>
                Close
              </Button>
              {/* Proceed button */}
              <Button
                colorScheme="red"
                isLoading={status === ReducerStatus.LOADING}
                onClick={onConfirm}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

ConfirmationActionModal.defaultProps = {
  error: null,
  description: '',
  children: null,
};

ConfirmationActionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onSubmitResult: PropTypes.func.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
  isVisible: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired,
  error: PropTypes.object,
};

export default ConfirmationActionModal;
